import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Home, Mail, MapPin, ShieldCheck } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative bg-brand-emerald text-white/90 mt-20 grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-4 relative z-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center">
              <Home className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading font-bold text-xl text-white">{t("brand")}</span>
          </div>
          <p className="font-heading text-2xl font-semibold text-white mb-3">"{t("tagline")}"</p>
          <p className="text-sm max-w-md text-white/70">{t("hero.sub")}</p>
          <p className="text-xs mt-4 text-white/50">mypropertyas.com — Where You Like, India</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/browse" className="hover:text-white transition-colors">{t("nav.browse")}</Link></li>
            <li><Link to="/register" className="hover:text-white transition-colors">{t("nav.register")}</Link></li>
            <li><Link to="/terms" className="hover:text-white transition-colors">{t("nav.terms")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> Where You Like</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> support@mypropertyas.com</li>
            <li className="flex items-center gap-2"><ShieldCheck className="w-4 h-4" /> A connecting platform only</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 relative z-10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 space-y-4">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-testid="footer-legal-links">
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">Terms and Conditions</Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/grievance" className="hover:text-white transition-colors" data-testid="footer-grievance">Grievance Redressal</Link>
            <Link to="/refund" className="hover:text-white transition-colors" data-testid="footer-refund">Refund Policy</Link>
          </div>
          <p className="text-[11px] leading-relaxed text-white/50 text-center max-w-4xl mx-auto" data-testid="footer-disclaimer">
            Disclaimer: mypropertyas.com is an online property classifieds and subscription-based listing platform. We act strictly as an intermediary under Section 2(1)(w) of the IT Act, 2000. We do not verify, endorse, own, or guarantee the legality, title, or physical condition of any properties listed. Users are advised to conduct independent due diligence before entering into transactions.
          </p>
          <p className="text-xs text-white/60 text-center" data-testid="footer-copyright">© 2026 My Property. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
